import Component from './Component';
import Modal from './Modal';
import { hasError, showError, removeError, handleEvents } from './../services/FormValidation';
import axios from 'axios';
import Clipboard from 'clipboard';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */

// let modalElm = document.querySelector('.js-modal');
let modal;
let newPromise;
let copied = false;

const qs = window.Questions;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */


function copy (selector, target, icon ,message = '') {
    let success = document.createElement('span');
        success.className = 'o-error';
        success.innerHTML = message;

    const clipboard = new Clipboard(selector);

    clipboard.on('success', e => {

        target.parentNode.insertBefore(success, target.nextSibling);
        success.classList.add('is-active');

        setTimeout(() => {
            success.classList.add('is-visible');
            icon.classList.add('is-active');
        }, 100);

        // clear selection
        // remove message
        setTimeout(() => {
            success.classList.remove('is-visible');
            icon.classList.remove('is-active');

            setTimeout(() => {
                success.classList.remove('is-active');
                success.remove();
                e.clearSelection();
            }, 300);
        }, 2000)
    });

    return clipboard;
}




/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class ApplicationForm extends Component {

    decorator () {
        return {
            selector : '.js-application-form',
            name : 'ApplicationForm',
        }
    }


    constructor(element) {
        super(element);

        let modalElm = document.querySelector('.js-modal');

        modal = Modal.bindElement(modalElm);

        // INITIAL CALLS
        this.cacheElements();

        this.toggleElements();
    }


    cacheElements () {
        this.saveProgressSel = Array.from(this.element.querySelectorAll('.js-save-progress'));
        this.saveProgressTemplate = document.querySelector('#save-progress-template');
    }


    toggleElements() {
        this.saveProgressSel.forEach((item, idx) => {
            item.addEventListener('click', e => {
                e.preventDefault();
                modal.open('save-progress-template', this.bindElements.bind(this));
            });
        });
    }


    bindElements() {
        this.$content = modal.$content.querySelector('.js-save-progress-content');
        this.$close = Array.from(this.$content.querySelectorAll('.js-save-progress-close'));
        this.$preloader = this.$content.querySelector('.js-save-progress-preloader');
        this.$form = document.getElementsByName('save_progress_form');
        this.$formElements = this.$form[0].elements;
        this.$form_link = this.$form[0].elements['save_progress_link'];
        this.$form_email = this.$form[0].elements['save_progress_email'];
        this.$form_button = this.$form[0].elements['save_progress_button'];

        this.$copy = this.$content.querySelector('.js-copy');

        this.bindEvents();
    }


    bindEvents () {
        handleEvents(this.$form[0]);
        this.$close.forEach(item => item.addEventListener('click', e => modal.close()));
        this.$form[0].addEventListener('submit', this.saveProgressSubmitForm.bind(this));

        copy(this.$copy, this.$form_link, this.$copy, 'Link Copied');
        copy(this.$form_link, this.$form_link, this.$copy, 'Link Copied');
    }



    // on submit form
    saveProgressSubmitForm (e) {
        e.preventDefault();

        const fields = e.target.elements;

        let error,
            hasErrors;

        for (let i = 0; i < fields.length; i++) {
            error = hasError(fields[i]);

            if (error) {
                showError(this.$formElements, fields[i], error);

                if (!hasErrors) {
                    hasErrors = fields[i];
                }
            }

            if (hasErrors) {
                hasErrors.focus();
            }
        }

        if (typeof hasErrors != 'undefined') { return; }

        this.disableFields();

        this.sendToEmail(this.$form_link.value, this.$form_email.value);
    }


    sendToEmail (url, email) {
        newPromise = axios.post('/api/application/save-progress', {
                url: url,
                email: email,
                link: qs.link
            })
            .then(response => {
                this.onSuccess();
            })
            .catch(error => {
                this.enableFields();
                console.error(error);
            })
    }


    disableFields () {
        this.$form_email.setAttribute('disabled', '');
        this.$form_button.setAttribute('disabled', '');
        this.$preloader.classList.add('is-active');

        setTimeout(() => {
            this.$preloader.classList.add('is-visible');
        }, 350);
    }


    enableFields() {
        this.$form_email.removeAttribute('disabled');
        this.$form_button.removeAttribute('disabled');
        this.$preloader.classList.remove('is-visible');

        setTimeout(() => {
            this.$preloader.classList.remove('is-active');
        }, 350);
    }


    onSuccess () {
        this.enableFields();
        modal.close();
        setTimeout(() => {
            modal.open('save-progress-success', {});
            const $close = modal.$content.querySelector('.js-modal-close');
            $close.addEventListener('click', e => modal.close());
        }, 750);
    }

}
